import React from 'react';
import { Grid, Typography } from '@mui/material';
import useStyles from '../styles';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const stopperLeft = styled(Paper)(({ theme }) => ({
   width: '-webkit-fill-available',
    [theme.breakpoints.down('xs')]: { 
      display:'none'
    },
    '& img': {
      width: '-webkit-fill-available',
      height: '-webkit-fill-available'
    }
}));




export default function Stopper(props) {
  const classes = useStyles();
  const MIN_HEIGHT = '20vh';

  const introText = props.init && props.init.formTexts.NewsLetterIntro;

  return (
    <Grid container spacing={6} style={{ background: `url(${props.currentCycle && props.currentCycle.bannerUrl}) no-repeat center 80%`, minHeight: MIN_HEIGHT, width: '-webkit-fill-available', 'background-size': 'cover', '-moz-background-size': 'cover', '-webkit-background-size': 'cover' }}>
      <Grid size={{ sm: 8, xs:false }} className={stopperLeft}>
      </Grid>
      <Grid size={{ sm: 4, xs:12 }} >
         <div className={classes.stopperRight} style={{ backgroundColor: '#fff', padding: 12, margin: '0px', opacity: 0.92, borderBottom: '1px solid #ccc', minHeight: MIN_HEIGHT }}> 
          <Typography component="h1" variant="h6" style={{fontFamily:'Rockwell-MT', paddingBottom:10, borderBottom:14,color:'#8aaf45'}}  className={classes.subTitle} color="secondary" gutterBottom>
            {props.currentCycle && props.currentCycle.title}
          </Typography>
          <Typography component="div" variant="" style={{fontFamily:'Rockwell-MT', fontSize: '0.875rem', borderBottom:14,color:'#8aaf45'}} color="secondary" gutterBottom>
            <div dangerouslySetInnerHTML={{ __html: introText }}></div>
          </Typography>
        </div>
      </Grid>
    </Grid>
  )
}